<app-layout>
  <div *ngIf="irsaliye">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">
              Talep Bilgileri
            </h3>
          </div>
          <div class="card-body">
            <app-talep-detay [source]="irsaliye.siparis.talep"></app-talep-detay>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card p-0">
          <div class="card-header">
            <h3 class="card-title">İrsaliye Kalemleri</h3>
          </div>
          <div class="table-responsive">
            <table class="table card-table table-vcenter text-nowrap datatable">
              <thead>
              <tr>
                <th class="w-1">Stok Kodu</th>
                <th>Stok Adı</th>
                <th>Ölçü Birimi</th>
                <th>İrsaliye Adet</th>
                <th>İrsaliye Birim Fiyat</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let k of irsaliye.irsaliyeKalemler;let i=index;">
                <td><span class="text-muted">{{k.teklifKalem.talepKalem.stokKodu}}</span></td>
                <td>{{k.teklifKalem.talepKalem.stokAdi}}</td>
                <td>{{k.teklifKalem.talepKalem.olcuBirimi}}</td>
                <td><input type="number" class="form-control"
                           [(ngModel)]="k.adet"></td>
                <td><input type="number" class="form-control" [readonly]="userGrupId !== 1"
                           [(ngModel)]="k.tutar"></td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer text-right">
            <b>İrsaliye Toplamı:</b> {{totalTutarText}}
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card p-0">
          <div class="card-header">
            <h3 class="card-title">Onay</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-3">
                <div class="mb-3">
                  <label class="form-label">İrsaliye No</label>
                  <input class="form-control" [(ngModel)]="irsaliye.irsaliyeNo"/>
                </div>
              </div>
              <div class="col-3">
                <div class="mb-3">
                  <label class="form-label">İrsaliye Tarihi</label>
                  <div class="input-icon">
                    <input
                      mwlFlatpickr
                      class="form-control mb-2 flatpickr-input"
                      type="text"
                      placeholder="İrsaliye Tarihi"
                      [(ngModel)]="irsaliye.irsaliyeTarihi"
                      [altInput]="true"
                      [convertModelValue]="true">
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="mb-3">
                  <div class="form-label">İrsaliye Notu</div>
                  <textarea class="form-control" name="example-textarea-input" rows="1" placeholder="İrsaliye Notu"
                            [(ngModel)]="irsaliye.irsaliyeNotu"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer text-right">
            <div class="btn btn-success" (click)="save()">Kaydet</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-layout>
